/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * TFA API
 * API for TFA
 * OpenAPI spec version: 2.0.0 (api.admin.v1)
 */
import type {
  AdminCalendar,
  AdminV1OrganizationsCalendarsListParams,
  PaginatedAdminCalendarList,
  PatchedAdminCalendar
} from '.././model';

import adminV1OrganizationsCalendarsListMutator from '../../shared/services/axios-client';
import adminV1OrganizationsCalendarsCreateMutator from '../../shared/services/axios-client';
import adminV1OrganizationsCalendarsRetrieveMutator from '../../shared/services/axios-client';
import adminV1OrganizationsCalendarsUpdateMutator from '../../shared/services/axios-client';
import adminV1OrganizationsCalendarsPartialUpdateMutator from '../../shared/services/axios-client';
import adminV1OrganizationsCalendarsDestroyMutator from '../../shared/services/axios-client';

// https://stackoverflow.com/questions/49579094/typescript-conditional-types-filter-out-readonly-properties-pick-only-requir/49579497#49579497
type IfEquals<X, Y, A = X, B = never> = (<T>() => T extends X ? 1 : 2) extends <
T,
>() => T extends Y ? 1 : 2
? A
: B;

type WritableKeys<T> = {
[P in keyof T]-?: IfEquals<
  { [Q in P]: T[P] },
  { -readonly [Q in P]: T[P] },
  P
>;
}[keyof T];

type UnionToIntersection<U> =
  (U extends any ? (k: U)=>void : never) extends ((k: infer I)=>void) ? I : never;
type DistributeReadOnlyOverUnions<T> = T extends any ? NonReadonly<T> : never;

type Writable<T> = Pick<T, WritableKeys<T>>;
type NonReadonly<T> = [T] extends [UnionToIntersection<T>] ? {
  [P in keyof Writable<T>]: T[P] extends object
    ? NonReadonly<NonNullable<T[P]>>
    : T[P];
} : DistributeReadOnlyOverUnions<T>;



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  /**
 * Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 * @summary Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 */
export const adminV1OrganizationsCalendarsList = (
    organizationId: number,
    params?: AdminV1OrganizationsCalendarsListParams,
 options?: SecondParameter<typeof adminV1OrganizationsCalendarsListMutator<PaginatedAdminCalendarList>>,) => {
      return adminV1OrganizationsCalendarsListMutator<PaginatedAdminCalendarList>(
      {url: `/api/admin/v1/organizations/${organizationId}/calendars/`, method: 'GET',
        params
    },
      options);
    }
  /**
 * Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 * @summary Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 */
export const adminV1OrganizationsCalendarsCreate = (
    organizationId: number,
    adminCalendar: NonReadonly<AdminCalendar>,
 options?: SecondParameter<typeof adminV1OrganizationsCalendarsCreateMutator<AdminCalendar>>,) => {
      return adminV1OrganizationsCalendarsCreateMutator<AdminCalendar>(
      {url: `/api/admin/v1/organizations/${organizationId}/calendars/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: adminCalendar
    },
      options);
    }
  /**
 * Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 * @summary Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 */
export const adminV1OrganizationsCalendarsRetrieve = (
    organizationId: number,
    id: number,
 options?: SecondParameter<typeof adminV1OrganizationsCalendarsRetrieveMutator<AdminCalendar>>,) => {
      return adminV1OrganizationsCalendarsRetrieveMutator<AdminCalendar>(
      {url: `/api/admin/v1/organizations/${organizationId}/calendars/${id}/`, method: 'GET'
    },
      options);
    }
  /**
 * Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 * @summary Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 */
export const adminV1OrganizationsCalendarsUpdate = (
    organizationId: number,
    id: number,
    adminCalendar: NonReadonly<AdminCalendar>,
 options?: SecondParameter<typeof adminV1OrganizationsCalendarsUpdateMutator<AdminCalendar>>,) => {
      return adminV1OrganizationsCalendarsUpdateMutator<AdminCalendar>(
      {url: `/api/admin/v1/organizations/${organizationId}/calendars/${id}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: adminCalendar
    },
      options);
    }
  /**
 * Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 * @summary Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 */
export const adminV1OrganizationsCalendarsPartialUpdate = (
    organizationId: number,
    id: number,
    patchedAdminCalendar: NonReadonly<PatchedAdminCalendar>,
 options?: SecondParameter<typeof adminV1OrganizationsCalendarsPartialUpdateMutator<AdminCalendar>>,) => {
      return adminV1OrganizationsCalendarsPartialUpdateMutator<AdminCalendar>(
      {url: `/api/admin/v1/organizations/${organizationId}/calendars/${id}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedAdminCalendar
    },
      options);
    }
  /**
 * **Warning: Deleting a Calendar will delete all it's Workouts and StartedWorkouts of this Calendar. This action cannot be undone. Make huge warning on frontend!**
 * @summary Delete Calendar. Please read description!
 */
export const adminV1OrganizationsCalendarsDestroy = (
    organizationId: number,
    id: number,
 options?: SecondParameter<typeof adminV1OrganizationsCalendarsDestroyMutator<void>>,) => {
      return adminV1OrganizationsCalendarsDestroyMutator<void>(
      {url: `/api/admin/v1/organizations/${organizationId}/calendars/${id}/`, method: 'DELETE'
    },
      options);
    }
  export type AdminV1OrganizationsCalendarsListResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsCalendarsList>>>
export type AdminV1OrganizationsCalendarsCreateResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsCalendarsCreate>>>
export type AdminV1OrganizationsCalendarsRetrieveResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsCalendarsRetrieve>>>
export type AdminV1OrganizationsCalendarsUpdateResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsCalendarsUpdate>>>
export type AdminV1OrganizationsCalendarsPartialUpdateResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsCalendarsPartialUpdate>>>
export type AdminV1OrganizationsCalendarsDestroyResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsCalendarsDestroy>>>
